module.exports = __webpack_public_path__ + "media/images/baseline_check_black_18dp-c84e5139.png";